var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtaInteraction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 121,
    viewBox: "0 0 139 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 121,
    rx: 8,
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 121,
    rx: 8,
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 70,
    height: 19,
    rx: 2,
    fill: "#3C8EF9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(-25px, -1px)"
    },
    d: "M124.755 67.2996C124.871 67.2288 124.954 67.115 124.986 66.9832C125.018 66.8513 124.996 66.7123 124.925 66.5964L123.808 64.7684L124.773 64.1788C124.833 64.142 124.883 64.0909 124.919 64.0301C124.954 63.9693 124.974 63.9007 124.977 63.8303C124.98 63.7599 124.965 63.6899 124.934 63.6266C124.903 63.5633 124.857 63.5085 124.8 63.4673L120.547 60.6429C120.485 60.5976 120.41 60.5717 120.333 60.5687C120.256 60.5656 120.179 60.5855 120.113 60.6257C120.047 60.666 119.995 60.7249 119.962 60.795C119.93 60.8651 119.919 60.9433 119.93 61.0196L120.463 66.1174C120.473 66.187 120.501 66.2529 120.543 66.3093C120.586 66.3656 120.641 66.4106 120.705 66.4403C120.769 66.4699 120.839 66.4834 120.91 66.4794C120.98 66.4754 121.048 66.4541 121.108 66.4174L122.073 65.8278L123.19 67.6558C123.261 67.7715 123.375 67.8544 123.507 67.8863C123.639 67.9181 123.778 67.8963 123.894 67.8256L124.755 67.2996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(-25px, -1px)"
    },
    d: "M118.725 56.7803C118.649 56.6484 118.523 56.5519 118.376 56.5118C118.23 56.4716 118.073 56.4911 117.94 56.566C117.808 56.6408 117.71 56.765 117.668 56.9115C117.627 57.058 117.645 57.215 117.718 57.3483L118.74 59.1574C118.816 59.2893 118.941 59.3858 119.088 59.426C119.235 59.4661 119.391 59.4466 119.524 59.3718C119.657 59.2969 119.754 59.1727 119.796 59.0262C119.837 58.8797 119.819 58.7227 119.746 58.5894L118.725 56.7803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(-25px, -1px)"
    },
    d: "M121.935 59.1395C122.083 59.1797 122.241 59.1596 122.374 59.0835C122.507 59.0075 122.604 58.8817 122.645 58.7338L123.191 56.7297C123.231 56.5819 123.211 56.4241 123.135 56.2911C123.059 56.158 122.933 56.0607 122.786 56.0204C122.638 55.98 122.48 56.0001 122.347 56.0761C122.214 56.1521 122.116 56.2779 122.076 56.4258L121.53 58.4301C121.49 58.5779 121.51 58.7357 121.586 58.8687C121.662 59.0017 121.787 59.0991 121.935 59.1395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(-25px, -1px)"
    },
    d: "M117.728 60.832L115.73 60.2641C115.583 60.224 115.426 60.2434 115.294 60.3181C115.161 60.3929 115.064 60.517 115.022 60.6634C114.98 60.8098 114.998 60.9667 115.072 61.1C115.145 61.2333 115.268 61.3323 115.414 61.3754L117.412 61.9433C117.559 61.9835 117.716 61.964 117.849 61.8893C117.981 61.8145 118.079 61.6904 118.12 61.544C118.162 61.3976 118.144 61.2407 118.071 61.1074C117.997 60.9741 117.874 60.8751 117.728 60.832Z",
    fill: "white"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaInteraction);
export default __webpack_public_path__ + "static/media/cta-interaction.6683b4f5088c1e240678d70794723c05.svg";
export { ForwardRef as ReactComponent };